import projectService from '../api/project'

const state = {
    selectedProject: null,
    projects: [],
}

const getters = {

}

const actions = {
    getProject ({ commit, state, dispatch }, projectId) {
        const requestId = 'GET_PROJECT_' + projectId
        commit('title/resetTitle', '', {root: true})
        commit('setSelectedProject', null)
        commit('ui/enableLoader', requestId, { root: true })

        return projectService.find(projectId ? projectId : state.selectedProject.id).then(response => {
            const project = response.data
            commit('setSelectedProject', project)
            commit('title/updateTitle', project.title, {root: true})

            return project
        }, () => false).finally(() =>  commit('ui/disableLoader', requestId, { root: true }));
    },

    search ({ commit, state, dispatch }, { query, page = null, paginationSize = null }) {
        return projectService.search(query, page, paginationSize).then(response => {
            const result = response.data
            const projects = result.data ? result.data : result

            return projects
        }, () => false)
    },

    getProjects ({commit, state}) {
        return projectService.all(state.page).then(response => {
            const result = response.data
            const projects = result.data ? result.data : result

            commit('setProjects', projects)

            return projects
        }, () => false)
    },
}

const mutations = {
    setSelectedProject (state, project) {
        state.selectedProject = project
    },

    setProjects (state, projects) {
        state.projects = projects
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
